export default "__VITE_ASSET__A1Zs0VgGbFRHOHpdguoNIw__"